"use client";

import { Modal, Button } from "antd";
import Cookies from "js-cookie";

export default function DeliveryCountryModal({
  open,
  productCountry,
  cartCountry,
  cartItems = [],
  conflictType,
  onClose,
}) {
  const mainColor = Cookies.get("main_theme") || "#d62314";

  const isLocalIntoForeign = conflictType === "local_into_foreign";
  const isForeignIntoLocal = conflictType === "foreign_into_local";

  const title =
    isLocalIntoForeign || isForeignIntoLocal
      ? "Cart reserved for another country"
      : "Different Delivery Country";

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      title={title}
    >
      {isLocalIntoForeign ? (
        <div style={{ marginBottom: 16 }}>
          <p
            style={{
              fontSize: 15,
              lineHeight: 1.7,
              marginBottom: 10,
              color: "#222",
            }}
          >
            Your cart already has products related to{" "}
            <strong style={{ color: mainColor }}>{cartCountry}</strong>.
          </p>
          <p
            style={{
              fontSize: 14,
              lineHeight: 1.7,
              marginBottom: 0,
              color: "#555",
            }}
          >
            Please remove the <strong>{cartCountry}</strong> items from your
            cart first, then add this product.
          </p>
        </div>
      ) : isForeignIntoLocal ? (
        <div style={{ marginBottom: 16 }}>
          <p
            style={{
              fontSize: 15,
              lineHeight: 1.7,
              marginBottom: 10,
              color: "#222",
            }}
          >
            This product belongs to{" "}
            <strong style={{ color: mainColor }}>{productCountry}</strong>.
          </p>
          <p
            style={{
              fontSize: 14,
              lineHeight: 1.7,
              marginBottom: 0,
              color: "#555",
            }}
          >
            Please remove the items currently in your cart first, then add this
            product.
          </p>
        </div>
      ) : (
        <p style={{ fontSize: 15, lineHeight: 1.7, marginBottom: 16 }}>
          This product belongs to{" "}
          <strong style={{ color: mainColor }}>{productCountry}</strong>. Your
          cart already has items from{" "}
          <strong style={{ color: mainColor }}>{cartCountry}</strong>. Please
          remove those items from your cart first, then add this product.
        </p>
      )}

      {cartItems?.length > 0 ? (
        <div
          style={{
            marginBottom: 16,
            maxHeight: 240,
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            borderRadius: 8,
            padding: "4px 12px",
            background: "#fafafa",
          }}
        >
          {cartItems.map((item, index) => (
            <div
              key={item?.id || index}
              style={{
                display: "flex",
                gap: 10,
                alignItems: "flex-start",
                padding: "10px 0",
                borderBottom:
                  index === cartItems.length - 1
                    ? "none"
                    : "1px solid #f0f0f0",
              }}
            >
              {item?.img_url ? (
                <img
                  src={item.img_url}
                  alt={item.title}
                  width={48}
                  height={64}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
              ) : null}
              <div style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    lineHeight: 1.4,
                  }}
                >
                  {item.title}
                </div>
                {item.sku ? (
                  <div style={{ fontSize: 12, color: "#888" }}>
                    SKU: {item.sku}
                  </div>
                ) : null}
                {item.country ? (
                  <div
                    style={{
                      fontSize: 12,
                      color: mainColor,
                      marginTop: 2,
                      fontWeight: 500,
                    }}
                  >
                    Country: {item.country}
                  </div>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      ) : null}

      <Button
        type="primary"
        block
        onClick={onClose}
        style={{
          backgroundColor: mainColor,
          borderColor: mainColor,
          height: 40,
        }}
      >
        OK
      </Button>
    </Modal>
  );
}
